import React, { useState, useRef, useEffect } from 'react';
import PDFViewer from './PDFViewer';
import styles from '../../styles/Building MGMT/ApplicantModal.module.css';

const ApplicantDetailsModal = ({ applicant, onClose, onAccept, onReject }) => {
  if (!applicant) return null;

  const [messages, setMessages] = useState([
    { text: 'Application Submitted - 2 hrs ago', type: 'activity' },
    { text: 'Applicant message example', type: 'applicant' },
    { text: 'Your reply example', type: 'landlord' },
  ]);
  const [input, setInput] = useState('');
  const chatEndRef = useRef(null);

  const handleSend = () => {
    if (!input.trim()) return;

    setMessages(prev => [...prev, { text: input, type: 'landlord' }]);
    setInput('');

    setTimeout(() => {
      setMessages(prev => [...prev, { text: 'Response from applicant', type: 'applicant' }]);
    }, 1000);
  };

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <h2 className={styles.header}>Applicant Details</h2>
          <div className={styles.headerActions}>
            <button className={styles.acceptBtn} onClick={() => onAccept(applicant.id)}>Accept</button>
            <button className={styles.rejectBtn} onClick={() => onReject(applicant.id)}>Reject</button>
            <button className={styles.close} onClick={onClose}>✖️</button>
          </div>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.leftSection}>
            <div className={styles.infoCard}>
              <span className={styles.label}>Credit Score</span>
              <span className={styles.value}>{applicant.creditScore}</span>
              <PDFViewer buttonClass={styles.pdfButton} />
            </div>
            <div className={styles.infoCard}>
              <span className={styles.label}>Income</span>
              <span className={styles.value}>{applicant.income} ({applicant.incomeRentRatio}x)</span>
              <button className={styles.pdfButton}>📄 View PDF</button>
            </div>
            <div className={styles.infoCard}>
              <span className={styles.label}>Adverse Events</span>
              <span className={styles.value}>{applicant.adverse}</span>
              <button className={styles.pdfButton}>📄 View PDF</button>
            </div>
            <div className={styles.infoCard}>
              <span className={styles.label}>Criminal Background</span>
              <span className={styles.value}>{applicant.criminal}</span>
              <button className={styles.pdfButton}>📄 View PDF</button>
            </div>
          </div>

          <div className={styles.chatSection}>
            <div className={styles.chatMessages}>
			{messages.map((msg, idx) => (
			  msg.type === 'activity' ? (
				<div key={idx} className={styles.activityBar}>{msg.text}</div>
			  ) : (
				<div key={idx} className={msg.type === 'applicant' ? styles.applicantMessage : styles.yourMessage}>
				  {msg.text}
				</div>
			  )
			))}
            <div ref={chatEndRef} />
            </div>
            <div className={styles.messageInput}>
              <input
                type="text"
                placeholder="Type your message..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleSend()}
              />
              <button className={styles.sendButton} onClick={handleSend}>Send</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicantDetailsModal;
